export const progressBar = `<svg width="153" height="4" viewBox="0 0 153 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="153" height="4" rx="2" fill="#E9E6E7"/>
<rect width="22" height="4" rx="2" fill="#317ED9"/>
</svg>
`;
